(function() {
  if (window.__collectionProductSliderAssetLoaded) {
    return;
  }

  window.__collectionProductSliderAssetLoaded = true;

  function handleize(value) {
    return String(value || '').toLowerCase().replace(/\s+/g, '-').replace(/[^a-z0-9_]+/g, '-').replace(/(^-|-$)/g, '');
  }

  function sanitizeCssColor(value) {
    var color = String(value || '').trim();
    var isValid = /^(#[0-9a-fA-F]{3,8}|rgba?\(\s*(\d{1,3}%?\s*,\s*){2}\d{1,3}%?(\s*,\s*(0|1|0?\.\d+|100%))?\s*\)|hsla?\(\s*\d{1,3}(deg)?\s*,\s*\d{1,3}%\s*,\s*\d{1,3}%(\s*,\s*(0|1|0?\.\d+|100%))?\s*\)|[a-zA-Z]+)$/.test(color);

    return isValid ? color : '';
  }

  function parseProductImages(card) {
    try {
      return JSON.parse((card.getAttribute('data-product-images') || '[]').replace(/&quot;/g, '"'));
    } catch (error) {
      return [];
    }
  }

  function extractColorCode(imageSrc) {
    var filename = (imageSrc || '').split('/').pop().toUpperCase();
    var match = filename.match(/^([A-Z]+\d+[A-Z]?)_([A-Z]+)_/);

    return match ? match[2] : null;
  }

  function resizeImageUrl(url, size) {
    var ext = (url.match(/\.(jpg|png|gif|webp)(\?|$)/i) || [])[1] || 'jpg';
    var pattern = new RegExp('(_\\d+x)?\\.' + ext, 'i');

    return url.replace(pattern, '_' + size + 'x.' + ext);
  }

  function findHoverImage(productImages, activeImage) {
    var colorName = activeImage.getAttribute('data-alt') || '';
    var activeSrc = activeImage.getAttribute('src') || '';
    var colorCode = extractColorCode(activeSrc);

    if (colorCode) {
      var token = '_' + colorCode + '_';
      var byCode = productImages.find(function(image) {
        var src = String(image.src || '').toUpperCase();

        return src.indexOf(token) !== -1 && src.indexOf('_BACK') !== -1;
      });

      if (byCode) {
        return byCode;
      }
    }

    if (colorName) {
      var byAlt = productImages.find(function(image) {
        return image.alt === colorName && String(image.src || '').toUpperCase().indexOf('_BACK') !== -1;
      });

      if (byAlt) {
        return byAlt;
      }
    }

    return null;
  }

  function updateHoverImage(card) {
    var activeImage = card.querySelector('img.product-card__image.active');
    var imageRatio = card.querySelector('.product-card__image-ratio');

    if (!activeImage || !imageRatio) {
      return;
    }

    var hoverImage = imageRatio.querySelector('.product-card__image__hover-image');
    var productImages = parseProductImages(card);
    var matchingHoverImage = findHoverImage(productImages, activeImage);

    if (!matchingHoverImage) {
      if (hoverImage) {
        hoverImage.remove();
      }

      return;
    }

    if (!hoverImage) {
      hoverImage = document.createElement('img');
      hoverImage.className = 'product-card__second-image product-card__image__hover-image';
      hoverImage.loading = 'lazy';
      imageRatio.appendChild(hoverImage);
    }

    hoverImage.src = resizeImageUrl(matchingHoverImage.src, 900);
    hoverImage.alt = matchingHoverImage.alt || '';
    hoverImage.setAttribute('data-color', activeImage.getAttribute('data-alt') || '');
  }

  function updateCardForColor(card, swatchButton) {
    var colorName = swatchButton.getAttribute('data-swatch-name') || '';
    var colorSlug = handleize(colorName);
    var matchingImage = null;
    var swatch = swatchButton.querySelector('.product-card__swatch');
    var variantId = swatch ? swatch.getAttribute('data-variant-id') : '';

    if (variantId) {
      card.setAttribute('data-current-variant-id', variantId);
      card.setAttribute('data-dy-sku', variantId);
    }

    card.querySelectorAll('.product-card__swatch-border').forEach(function(button) {
      button.classList.toggle('active', button === swatchButton);
    });

    card.querySelectorAll('.product-card__image').forEach(function(image) {
      var isMatch = handleize(image.getAttribute('data-alt')) === colorSlug;

      image.classList.toggle('active', isMatch);

      if (isMatch) {
        matchingImage = image;
      }
    });

    if (!matchingImage) {
      var firstImage = card.querySelector('.product-card__image');

      if (firstImage) {
        firstImage.classList.add('active');
      }
    }

    var availableSizes = (swatchButton.getAttribute('data-available-sizes') || '').split(',').map(function(size) {
      return size.trim();
    }).filter(Boolean);

    card.querySelectorAll('.product-card__size-swatch').forEach(function(sizeButton) {
      var sizeValue = sizeButton.getAttribute('data-size-value');
      var isAvailable = availableSizes.indexOf(sizeValue) !== -1;

      sizeButton.classList.toggle('product-oos', !isAvailable);
      sizeButton.disabled = !isAvailable;
    });

    card.querySelectorAll('[data-quickshop-trigger], .product-card__quick-view-trigger').forEach(function(trigger) {
      trigger.setAttribute('data-color-slug', colorSlug);
    });

    var badge = card.querySelector('.product-card__badge-container');
    var badgeText = swatchButton.getAttribute('data-badge-in-collection') || '';

    if (badge) {
      if (badgeText) {
        badge.textContent = badgeText;
        badge.classList.remove('d-none');
        badge.style.backgroundColor = sanitizeCssColor(swatchButton.getAttribute('data-product-badge-background-color'));
        badge.style.color = sanitizeCssColor(swatchButton.getAttribute('data-product-badge-text-color'));
      } else {
        badge.textContent = '';
        badge.classList.add('d-none');
        badge.style.backgroundColor = '';
        badge.style.color = '';
      }
    }

    var variantBadgeText = swatchButton.getAttribute('data-variant-badge-under-the-image') || '';
    var productBadge = card.querySelector('.badge__product-level');
    var variantBadge = card.querySelector('.badge__variant-level');

    if (variantBadgeText && variantBadge) {
      if (productBadge) {
        productBadge.classList.add('d-none');
      }

      variantBadge.textContent = variantBadgeText;
      variantBadge.classList.remove('d-none');
    } else if (variantBadge) {
      variantBadge.textContent = '';
      variantBadge.classList.add('d-none');

      if (productBadge && productBadge.textContent.trim()) {
        productBadge.classList.remove('d-none');
      }
    }

    updateHoverImage(card);

    if (typeof window.checkWishStatusForLoadedProducts === 'function') {
      window.checkWishStatusForLoadedProducts();
    }
  }

  function initProductCards(scope) {
    var root = scope || document;
    var cards = root.querySelectorAll('.collection-product-slider__product-card');

    cards.forEach(function(card) {
      if (card.getAttribute('data-collection-product-card-initialized') === 'true') {
        return;
      }

      card.setAttribute('data-collection-product-card-initialized', 'true');

      card.addEventListener('click', function(event) {
        var swatchButton = event.target.closest('.product-card__swatch-border');

        if (!swatchButton || !card.contains(swatchButton)) {
          return;
        }

        event.preventDefault();
        updateCardForColor(card, swatchButton);
      });

      var activeSwatch = card.querySelector('.product-card__swatch-border.active') || card.querySelector('.product-card__swatch-border');

      if (activeSwatch) {
        updateCardForColor(card, activeSwatch);
      } else {
        updateHoverImage(card);
      }
    });
  }

  function initCollectionProductSlider(scope) {
    var root = scope || document;
    var sliders = root.querySelectorAll('[data-collection-product-slider-track]');

    sliders.forEach(function(slider) {
      if (slider.getAttribute('data-collection-product-slider-initialized') === 'true') {
        return;
      }

      if (!window.jQuery || typeof window.jQuery.fn.slick !== 'function') {
        return;
      }

      var $slider = window.jQuery(slider);
      var desktopSlides = parseInt(slider.getAttribute('data-desktop-slides'), 10) || 4;
      var mobileSlides = parseInt(slider.getAttribute('data-mobile-slides'), 10) || 2;

      slider.setAttribute('data-collection-product-slider-initialized', 'true');

      if (typeof window.initializeProductCardSwatchImageFallbacks === 'function') {
        window.initializeProductCardSwatchImageFallbacks(slider);
      }

      initProductCards(slider);

      $slider.slick({
        arrows: true,
        dots: false,
        infinite: false,
        slidesToScroll: 1,
        slidesToShow: desktopSlides,
        swipeToSlide: true,
        responsive: [
          {
            breakpoint: 768,
            settings: {
              slidesToShow: mobileSlides
            }
          }
        ]
      });

      initProductCards(slider);
    });
  }

  document.addEventListener('DOMContentLoaded', function() {
    initProductCards();
    initCollectionProductSlider();
  });

  document.addEventListener('shopify:section:load', function(event) {
    if (event.target.querySelector('[data-collection-product-slider]')) {
      initCollectionProductSlider(event.target);
    }

    if (event.target.querySelector('[data-static-product-grid]')) {
      initProductCards(event.target);
    }
  });
})();
